import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Grid, Button } from '@mui/material';

import EntradaEstadia from './SubComponentsVehiculos/EntradaEstadia';
import EntradaMensualidad from './SubComponentsVehiculos/EntradaMensualidad';

const EntradaVehiculos = ({ handleChangePage, onCreatedRecord }) => {
  const [selected, setSelected] = useState('none')

  return (
    <>
    {selected === 'none' ? (
          <Grid container style={{ height: "100vh" }}>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              style={
                { 
                  height: "100%", 
                  fontSize: "2rem", 
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  padding: '20px',
                }}
              onClick={() => {setSelected('estadia')}}
            >
              ESTADIA
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              style={
                { 
                  height: "100%", 
                  fontSize: "2rem", 
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  color: 'white',
                  padding: '20px',
                }}
              onClick={() => {setSelected('mensualidad')}}
            >
              MENSUALIDAD
            </Button>
          </Grid>
        </Grid>
    ) : selected === 'estadia' ? (
      <EntradaEstadia handleChangePage={handleChangePage} onCreatedRecord={onCreatedRecord}/>
    ) : (
      <EntradaMensualidad handleChangePage={handleChangePage} onCreatedRecord={onCreatedRecord} />
    )}
    </>
  );
};

export default EntradaVehiculos;
